"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDropdown = void 0;
const react_1 = __importStar(require("react"));
const createDropdownStyle_1 = require("./helpers/createDropdownStyle");
const helpers_1 = require("../../helpers");
const Popover_1 = require("../../Popover");
const defaultPopoverRenderer_1 = require("./renderers/defaultPopoverRenderer");
function useDropdown({ ref, initialActiveState, autoClosable = true, renderContent, renderControl, popoverConfig, renderPopover = defaultPopoverRenderer_1.defaultPopoverRenderer, offset = 0, getAdditionalContentNode, onDidHide, onDidShow, dropdownWidth, onOutsideClick }) {
    const isActiveRef = (0, react_1.useRef)(!!initialActiveState);
    const actionsRef = (0, react_1.useRef)(null);
    const shownStateValue = (0, helpers_1.useStateValue)(!!initialActiveState, [initialActiveState], {
        onReset: (nextValue) => {
            var _a, _b;
            nextValue ? (_a = actionsRef.current) === null || _a === void 0 ? void 0 : _a.show() : (_b = actionsRef.current) === null || _b === void 0 ? void 0 : _b.hide();
        }
    });
    const actions = {
        hide: () => {
            isActiveRef.current = false;
            shownStateValue.setValue(false);
            onDidHide === null || onDidHide === void 0 ? void 0 : onDidHide();
        },
        show: () => {
            isActiveRef.current = true;
            shownStateValue.setValue(true);
            onDidShow === null || onDidShow === void 0 ? void 0 : onDidShow();
        },
        toggle: () => {
            let nextValue;
            shownStateValue.updateValue((value) => {
                nextValue = !value;
                isActiveRef.current = nextValue;
                return nextValue;
            });
            nextValue ? onDidShow === null || onDidShow === void 0 ? void 0 : onDidShow() : onDidHide === null || onDidHide === void 0 ? void 0 : onDidHide();
        }
    };
    actionsRef.current = actions;
    const [measureRef, measurableControl] = (0, Popover_1.useMeasureClientRect)(ref);
    const measureButton = measurableControl.measure();
    const isActive = shownStateValue.getValue();
    const controlReactNode = renderControl({
        isActive,
        actions,
        button: {
            ref: measureRef,
            onMouseDown: (mouseEvent) => {
                if (mouseEvent) {
                    mouseEvent.preventDefault();
                }
                actions.toggle();
            }
        }
    });
    const popover = (0, Popover_1.usePopover)({
        isActive,
        config: popoverConfig || [
            {
                xAxis: Popover_1.X_AXIS.insideLeft,
                yAxis: Popover_1.Y_AXIS.outsideBottom,
                offsetY: offset * -1
            },
            {
                xAxis: Popover_1.X_AXIS.insideRight,
                yAxis: Popover_1.Y_AXIS.outsideBottom,
                offsetY: offset * -1
            },
            { xAxis: Popover_1.X_AXIS.insideLeft, yAxis: Popover_1.Y_AXIS.outsideTop, offsetY: offset },
            { xAxis: Popover_1.X_AXIS.insideRight, yAxis: Popover_1.Y_AXIS.outsideTop, offsetY: offset }
        ],
        target: measurableControl,
        onKeyPress: (e) => {
            if (e.key === 'Escape') {
                if (autoClosable && isActive) {
                    actions.hide();
                }
            }
        },
        onOutsideClick: autoClosable && isActive
            ? (e) => {
                actions.hide();
                onOutsideClick === null || onOutsideClick === void 0 ? void 0 : onOutsideClick(e);
            }
            : undefined,
        onWindowScroll: (e) => {
            const parent = e.target;
            if (isActive && measureRef.current && parent.contains(measureRef.current)) {
                actions.hide();
            }
        },
        getAdditionalContentNode: () => {
            var _a;
            return [
                ...((_a = getAdditionalContentNode === null || getAdditionalContentNode === void 0 ? void 0 : getAdditionalContentNode()) !== null && _a !== void 0 ? _a : []),
                measurableControl.getDOMNode()
            ];
        },
        render: (popoverRef) => {
            var _a;
            return renderPopover({
                popover: {
                    ref: popoverRef,
                    style: Object.assign({}, (0, createDropdownStyle_1.createDropdownStyle)(measureButton === null || measureButton === void 0 ? void 0 : measureButton.width, dropdownWidth))
                },
                actions,
                content: (_a = renderContent === null || renderContent === void 0 ? void 0 : renderContent({ actions })) !== null && _a !== void 0 ? _a : null
            });
        }
    });
    const controlNode = (react_1.default.createElement(react_1.default.Fragment, null,
        controlReactNode,
        isActive && popover));
    return [
        controlNode,
        {
            isActive,
            deactivate: actions.hide,
            activate: actions.show
        }
    ];
}
exports.useDropdown = useDropdown;
//# sourceMappingURL=useDropdown.js.map